import { autoinject, useView, PLATFORM } from 'aurelia-framework';
import { Router, RouterConfiguration } from 'aurelia-router';
import { IDemoRouteConfig } from 'app/demo/lib/router-types';
import { DemoContentPageBase } from 'app/demo/pages/demo-content-page-base';


@autoinject()
@useView('./demo-content-page.html')
export class DemoAttributesPage extends DemoContentPageBase {

    ////****************** Fields and Properties ************************************////


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected async configureRouter(config: RouterConfiguration, router: Router): Promise<void> {
        const routes: IDemoRouteConfig[] = [
            { route: '', redirect: 'ess-tooltip' },
            {
                route: 'ess-tooltip', name: 'demo.attributes.ess-tooltip', moduleId: PLATFORM.moduleName('app/demo/pages/attributes/demo-ess-tooltip-page'), title: 'ess-tooltip', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/attributes/ess-tooltip.html' }
            },
            {
                route: 'ess-selectable-listbox', name: 'demo.attributes.ess-selectable-listbox', moduleId: PLATFORM.moduleName('app/demo/pages/attributes/demo-ess-selectable-listbox-page'), title: 'ess-selectable-listbox', nav: true,
                settings: { isVisible: true, bypassAuthentication: true, helpFragment: 'gui/shared/attributes/ess-selectable-listbox.html' }
            },
        ];
        config.map(routes);

        config.mapUnknownRoutes('app/shared/components/not-found');

        this.router = router;
    }

    ////****************** Service Calls ********************************************////

}
